import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Claim, Invoice, Pet, PetInsuranceData } from "../../models";
import { ActivatedRoute, Router } from "@angular/router";
import { DataStorageService } from "../../services/data-storage.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: 'cpf-claims-details-page',
  templateUrl: './claims-details-page.component.html',
  styleUrls: ['./claims-details-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClaimsDetailsPageComponent implements OnDestroy {
  public claim?: Claim;
  public petData?: PetInsuranceData;
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private dataStorageService: DataStorageService,
    private router: Router
  ) {
    this.route.params.pipe(
      takeUntil(this.destroy$)
    ).subscribe(params => {
      const claimId = params['id'];
      if (!claimId) {
        return;
      }

      const petWithClaim = this.findPetByClaimId(claimId);
      if (!petWithClaim) {
        this.router.navigate(['calingo', 'pet', 'claims']);
        return;
      }

      const claim = this.findClaimByIdForPet(petWithClaim, claimId);
      if (!claim) {
        this.router.navigate(['calingo', 'pet', 'claims']);
        return;
      }

      this.updateComponentState(petWithClaim, claim);
    });

    this.dataStorageService.selectedData$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(pet => {
      if (this.petData && pet && this.petData.full_contract_number === pet.full_contract_number) {
        return;
      }

      this.router.navigate(['calingo', 'pet', 'claims']);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private findPetByClaimId(claimId: string): PetInsuranceData | undefined {
    return this.dataStorageService.getAllData
      .find(pet => !!this.findClaimByIdForPet(pet, claimId));
  }

  private updateComponentState(pet: PetInsuranceData, claim: Claim): void {
    this.claim = claim;
    this.petData = pet;
    this.dataStorageService.selectedData = pet;
  }

  private findClaimByIdForPet(petWithClaim: PetInsuranceData, claimId: any) {
    return petWithClaim.claims?.find(claim => claim.identifier === claimId);
  }
}
